import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FullPageLoader from "../../components/Shared/FullPageLoader";
import PatientFileTable from "../../components/PatientFiles/PatientFilesTable";
import { FileUploadServiceInternal } from "../../services/fileUpload.service";
import { toast } from "react-toastify";
import "./../../components/Layout/Pagination/index.css";
import Layout from "../../components/Layout";

function PatientFiles() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () => {
        try {
            const response = await FileUploadServiceInternal.getFileTemplates();
            if (response?.data.isSuccess) {
                setData(response?.data.data);
                setIsLoading(false);
            } else {
                toast.error("No data found.");
                setIsLoading(false);
            }
        }
        catch (error) {
            toast.error("Failed to fetch data. Please try again later.");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Layout>
            {isLoading && <FullPageLoader />}
            <Typography
                sx={{
                    maxWidth: "100%",
                    minHeight: "70%",
                    maxHeight: "100%",
                    padding: 3,
                    margin: 2,
                    textAlign: "center",
                }}
            >
                <div className="patient-dashboard">
                    <div className="overflow-auto">
                        <PatientFileTable
                            data={data ?? []}
                        />
                    </div>
                </div>
            </Typography>
        </Layout>
    );
}
export default PatientFiles;